import React, { useContext, useEffect, useState } from 'react';
import { Button, CircularProgress, Typography } from '@material-ui/core';

import { warehouseApi } from 'api/warehouse';
import { UserContext } from 'contexts/UserContext';
import { Notifications } from 'shared';

function PalletEmptyAction({ onCancel, onSuccess, palletId }) {
    const [notification, setNotification] = useState({ text: null, level: null });
    const [loading, setLoading] = useState(false);
    const { user } = useContext(UserContext);

    useEffect(() => {
        if (!(onSuccess instanceof Function)) {
            console.error('PalletEmptyAction intialized incorrectly onSuccess is not a function');
        }
        if (!(onCancel instanceof Function)) {
            console.error('PalletEmptyAction intialized incorrectly onCancel is not a function');
        }
    }, [onSuccess]);

    const handleSubmit = async () => {
        setLoading(true);
        const result = await warehouseApi.palletEmpty(palletId, user.facilityID);
        setLoading(false);
        if (result.status) {
            onSuccess();
        } else {
            setNotification({ text: result.msg, level: 'error' });
        }
    };

    const handleCancel = () => {
        onCancel();
    };

    return (
        <div>
            <Notifications options={notification} />
            <Typography style={{ marginBottom: 10 }}> Is the pallet empty? </Typography>
            <Button onClick={handleCancel}>Cancel</Button>
            <Button onClick={handleSubmit} disabled={loading}>
                {loading ? <CircularProgress size={24} /> : 'Confirm'}
            </Button>
        </div>
    );
}

export { PalletEmptyAction };
